import React from 'react';
import HeroSection from '../components/HeroSection';
import ServiceCard from '../components/ServiceCard';
import './HotelsPage.css';

function HotelsPage() {
  return (
    <div className="hotels-page">
      <HeroSection
        backgroundImage="/images/hero_hotels.jpg"
        title="Hotel Carpet Cleaning — Discreet, Overnight Service"
        subtitle="Keep your hotel looking pristine for every guest. Thorough cleaning delivered around your occupancy — no disruption, no compromise."
        ctaText="Get a Hotel Cleaning Quote"
        ctaLink="/contact"
      />

      {/* Value Propositions */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Tailored to Hospitality</h2>
            <p>
              In hospitality, presentation is everything. Our service is built around 
              the unique demands of hotels — from high-traffic lobbies to guest rooms 
              that must be immaculate for every check-in.
            </p>
          </div>
          <div className="grid grid--3">
            <ServiceCard
              icon="&#128716;"
              title="Guest Rooms"
              description="Deep cleaning between stays or during quiet periods, ensuring a fresh, hygienic environment for every guest."
            />
            <ServiceCard
              icon="&#127963;"
              title="Lobbies &amp; Corridors"
              description="High-traffic areas receive specialist attention to maintain the welcoming first impression your guests expect."
            />
            <ServiceCard
              icon="&#127908;"
              title="Conference &amp; Function Rooms"
              description="Meeting and event spaces kept immaculate for business guests, conferences, and special occasions."
            />
          </div>
        </div>
      </section>

      {/* Lobby Image + Text */}
      <section className="section section--soft">
        <div className="container">
          <div className="split">
            <div className="split__image">
              <img
                src="/images/hotel_grand_lobby.jpg"
                alt="Grand British hotel lobby with pristine patterned carpet"
              />
            </div>
            <div className="split__content">
              <h2>Preserving Your Hotel's First Impression</h2>
              <p>
                Your lobby carpet is the first thing guests see — and the last thing they 
                should notice. We maintain it to a standard that quietly communicates 
                quality, care, and attention to detail.
              </p>
              <p>
                From traditional patterned carpets to modern neutral tones, we have the 
                expertise to clean and protect every type of hotel flooring.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Guest Room Image + Text */}
      <section className="section">
        <div className="container">
          <div className="split split--reverse">
            <div className="split__image">
              <img
                src="/images/hotel_guest_room_pristine.jpg"
                alt="Premium British hotel guest room with immaculate carpet"
              />
            </div>
            <div className="split__content">
              <h2>Guest Room Turnaround</h2>
              <p>
                Stains, odours, and wear accumulate fast in guest rooms. Our rapid 
                turnaround service restores carpets between bookings — so every guest 
                walks into a room that looks and feels brand new.
              </p>
              <p>
                Fast drying times mean rooms are ready again in hours, not days.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* USP Section */}
      <section className="section section--muted">
        <div className="container">
          <div className="section-header">
            <h2>We Work When Your Guests Don't</h2>
            <p>
              Discretion and flexibility are at the heart of our hotel service.
            </p>
          </div>
          <div className="feature-highlights">
            <div className="feature-highlight">
              <div className="feature-highlight__icon">&#9790;</div>
              <h3 className="feature-highlight__title">Unsociable Hours</h3>
              <p className="feature-highlight__desc">
                Early mornings, late nights, overnight — we work when your hotel 
                is at its quietest so guests are never disturbed.
              </p>
            </div>
            <div className="feature-highlight">
              <div className="feature-highlight__icon">&#9889;</div>
              <h3 className="feature-highlight__title">Quick Turnaround</h3>
              <p className="feature-highlight__desc">
                Rapid response when you need it. We can mobilise at short notice 
                to handle unexpected spills, stains, or last-minute bookings.
              </p>
            </div>
            <div className="feature-highlight">
              <div className="feature-highlight__icon">&#128222;</div>
              <h3 className="feature-highlight__title">Ready at Short Notice</h3>
              <p className="feature-highlight__desc">
                One call is all it takes. We can often start within 24 hours — 
                sometimes the same day.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Strong CTA */}
      <section className="sales-cta">
        <div className="container">
          <h2>Get Your Hotel Carpets Guest-Ready</h2>
          <p>
            Call now for a free, no-obligation quote tailored to your hotel's needs.
          </p>
          <a href="tel:+447887394404" className="sales-cta__phone">
            07887 394404
          </a>
          <button
            className="btn btn--accent btn--lg"
            onClick={() => window.location.href = '/contact'}
          >
            Or Request a Quote Online
          </button>
          <p className="sales-cta__sub">
            Same-day response guaranteed. Evening and weekend appointments available.
          </p>
        </div>
      </section>
    </div>
  );
}

export default HotelsPage;
